import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';
import clsx from "classnames";
import PropTypes from "prop-types";
import EditableImage from "@/components/EditableImage";
import EditableText from "@/components/EditableText";
import Link from "next/link"
import StarIcon from "/public/site-assets/svg/star.svg"
import OverlayDots from "/public/site-assets/svg/overlay-dots.svg"

export default function ImageWithTextQuote({
    className,
    global,
    pathPrefix,
    heading,
    content,
    button_cta_link,
    button_cta_title,
    imageURL,
    heading_tag
}) {
    return (
        <>
            <section className={clsx(className, styles.root)}>
                <Container>
                    <div className='position-relative'>
                        <div className='wrapper'>
                            <div className='position-relative z-index-1'>
                                {heading && (
                                    <EditableText
                                        content={heading}
                                        path={`${pathPrefix}.heading`}
                                        global={global}
                                        tag={`${heading_tag}`}
                                        className={`h3`}
                                    />
                                )}
                                {content && (
                                    <EditableText
                                        content={content}
                                        path={`${pathPrefix}.content`}
                                        global={global}
                                        tag={`div`}
                                        className={`content py-4`}
                                        html={true}
                                    />
                                )}
                                {button_cta_title && (
                                    <Link href={`${button_cta_link}`} className={`secondaryBtn m-0`}>{button_cta_title}</Link>
                                )}
                                <div className='overlay-dots position-absolute'><OverlayDots /></div>
                            </div>
                            <div className="position-relative pe-lg-5">
                                <span className='floating-icons'><StarIcon /></span>
                                <span className='floating-icons'><StarIcon /></span>
                                {imageURL && (
                                    <EditableImage
                                        className={`position-relative z-index-1`}
                                        img={{
                                            path: `${pathPrefix}.image`,
                                            src: `${imageURL ? imageURL : "/images/placeholders/img-placeholder.png"}`,
                                        }}
                                        size={"x570"}
                                        alt={``}
                                        height={`auto`}
                                    />
                                )}
                                <div className='overlay-dots position-absolute'><OverlayDots /></div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </>
    )
}

ImageWithTextQuote.defaultProps = {
    pathPrefix: "",
    className: "",
    heading_tag: "h3"

};

ImageWithTextQuote.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
    heading_tag: PropTypes.string
};